import { render, staticRenderFns } from "./AmiiVoiceShowcase.vue?vue&type=template&id=46fb34fc&scoped=true"
import script from "./AmiiVoiceShowcase.vue?vue&type=script&lang=js"
export * from "./AmiiVoiceShowcase.vue?vue&type=script&lang=js"
import style0 from "./AmiiVoiceShowcase.vue?vue&type=style&index=0&id=46fb34fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb34fc",
  null
  
)

export default component.exports